/* eslint-disable no-var */
/* eslint-disable no-unused-vars */
import { Modal, Row, Col } from 'react-bootstrap';
import docImage from '../../../assets/images/svg/doc.svg';
import { SimpleTag } from '../../tags';
import { SimpleCard } from '../../Card';
import CustomSelect2 from '../../customSelect2/CustomSelect2';
import {
  HeadingDesc,
  HeadingDescSmall,
  HeadingDescVsmall,
  HeadingWithSpaceLarge
} from '../../Headings';
import closeIcon from '../../../assets/images/svg/modal-close.svg';
import CustomCalender from '../../customCalender/CustomCalender';
import './sheduleAppointment.css';

const typeOfAppointment = [
  { value: 'in person', label: 'In Person' },
  { value: 'feb', label: 'Feb' }
];

const clinics = [
  { value: 'DHA Medical Clinic', label: 'DHA Medical Clinic' },
  { value: 'Malir Medical Clinic', label: 'Malir Medical Clinic' }
];

const reasonOfConsultation = [
  { value: 'Regular Check up', label: 'Regular Check up' },
  { value: 'Weekly Check up', label: 'Weekly Check up' }
];

function SheduleAppointment(props) {
  const { show, close, onClick } = props;

  return (
    <Modal
      show={show}
      className="modalLayout sheduleAppointment"
      onHide={close}
      centered
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Body>
        <div className="content">
          <Row>
            <Col md={7}>
              <div className="leftBox">
                <button
                  type="button"
                  className="modalCloseBtn mobile"
                  onClick={close}
                >
                  <img src={closeIcon} alt="closeIcon" />
                </button>
                <HeadingWithSpaceLarge text="RESCHEDULE APPOINTMENT" />
                <SimpleCard>
                  <Row className="docInfoCard">
                    <Col md={3}>
                      <div className="imgBox">
                        <img src={docImage} alt="docImage" />
                      </div>
                    </Col>
                    <Col md={9}>
                      <div className="info">
                        <div className="docName">
                          <HeadingDesc text="Prof. Dr. Nadia Khurshid Ahmed" />
                        </div>
                        <div className="speciality">
                          <HeadingDescSmall text="Gynecologist, Obstetrician" />
                        </div>
                        <div className="availabe one">
                          <HeadingDescSmall text="In-Person Appointment" />
                        </div>
                        <SimpleTag text="200" />
                      </div>
                    </Col>
                  </Row>
                </SimpleCard>
                <form>
                  <div className="infoBox">
                    <HeadingDescVsmall text="Select Type of Appointment" />
                    <CustomSelect2
                      options={typeOfAppointment}
                      defaultValue={typeOfAppointment[0]}
                    />
                  </div>
                  <div className="infoBox">
                    <HeadingDescVsmall text="Select Clinic" />
                    <CustomSelect2
                      options={clinics}
                      defaultValue={clinics[0]}
                    />
                  </div>
                  <div className="infoBox">
                    <HeadingDescVsmall text="Reason for Consultation" />
                    <CustomSelect2
                      options={reasonOfConsultation}
                      defaultValue={reasonOfConsultation[0]}
                    />
                  </div>
                </form>
              </div>
            </Col>
            <Col md={5}>
              <div className="rightBox">
                <button
                  type="button"
                  className="modalCloseBtn desktop"
                  onClick={close}
                >
                  <img src={closeIcon} alt="closeIcon" />
                </button>
                <div className="calenderLabel">
                  <HeadingDescVsmall text="Select available time" />
                </div>
                <div className="calender">
                  <CustomCalender />
                </div>
                <button
                  type="button"
                  className="simple_btn_small"
                  onClick={onClick}
                >
                  CONTINUE BOOKING
                </button>
                <HeadingDescVsmall text="You can change the date and time or cancel the Appointment 12 hours prior." />
              </div>
            </Col>
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default SheduleAppointment;
